import dayjs from "dayjs";
import { date, number, object } from "yup";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  discount: 0,
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxAmount: 0,
  taxPercentage: 11,
  subtotal: 0,
  grandTotal: 0,
  hasExternalPurchaseOrder: false,
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  paymentTerm: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  subtotal: number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .required("Harus diisi")
    .min(0, "Minimal 0"),
  grandTotal: number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .required("Harus diisi")
    .min(0, "Grand total tidak boleh kurang dari 0"),
  externalPurchaseOrder: object()
    .nullable()
    .when("hasExternalPurchaseOrder", {
      is: true,
      then: (schema) =>
        schema.shape({
          supplier: object().required("Harus diisi"),
          paymentTerm: object().required("Harus diisi"),
        }),
    }),
});
